import React, { useState, useEffect } from 'react';
import { X, MessageCircle, Phone } from 'lucide-react';

const WHATSAPP_NUMBER = '917757999805';
const WHATSAPP_MSG = encodeURIComponent('Hi Aquarist Pools and Fitness, I would like to enquire about swimming pool services.');
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MSG}`;

const WhatsAppButton = () => {
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowTooltip(true), 4000);
    return () => clearTimeout(t);
  }, []);

  const trackClick = (label) => {
    if (window.gtag) window.gtag('event', 'click', { event_category: 'CTA', event_label: label });
  };

  return (
    <div className="fixed bottom-20 md:bottom-6 right-4 md:right-6" style={{ zIndex: 9998 }} data-testid="whatsapp-floating-btn">
      {showTooltip && (
        <div className="absolute bottom-[68px] right-0 bg-white rounded-2xl shadow-2xl border border-gray-100 w-72 overflow-hidden animate-in fade-in slide-in-from-bottom-3 duration-300">
          <div className="bg-gradient-to-r from-[#25D366] to-[#128C7E] p-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                <MessageCircle className="w-5 h-5 text-white fill-white" />
              </div>
              <div>
                <p className="text-white font-semibold text-sm">Aquarist Pools</p>
                <p className="text-white/70 text-xs">Typically replies instantly</p>
              </div>
            </div>
            <button onClick={() => setShowTooltip(false)} className="text-white/60 hover:text-white" data-testid="whatsapp-tooltip-close">
              <X className="w-4 h-4" />
            </button>
          </div>
          <div className="p-4">
            <div className="bg-gray-50 rounded-xl p-3 mb-3">
              <p className="text-sm text-gray-700">Hello! Planning a pool? Get a <strong>FREE site consultation</strong>. Chat with us now.</p>
            </div>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackClick('whatsapp_tooltip_chat')}
              className="flex items-center justify-center gap-2 w-full bg-[#25D366] hover:bg-[#1ebe5d] text-white font-semibold py-2.5 rounded-xl transition-colors text-sm"
              data-testid="whatsapp-chat-link"
            >
              <MessageCircle className="w-4 h-4 fill-white" /> Chat on WhatsApp
            </a>
          </div>
        </div>
      )}

      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackClick('whatsapp_fab')}
        onMouseEnter={() => setShowTooltip(true)}
        className="group relative flex items-center justify-center w-14 h-14 bg-[#25D366] hover:bg-[#1ebe5d] rounded-full shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-110"
        data-testid="whatsapp-fab"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="w-7 h-7 text-white fill-white" />
        <span className="absolute -top-1 -right-1 w-3.5 h-3.5 bg-red-500 rounded-full border-2 border-white" />
      </a>
      <span className="absolute bottom-0 right-0 w-14 h-14 bg-[#25D366]/25 rounded-full animate-ping pointer-events-none" />
    </div>
  );
};

export default WhatsAppButton;
